import type { DocumentWithPublicity } from './firebase.ts'

export enum VisibilityType {
    draft = 'draft',
    hidden = 'private',
    unlisted = 'unlisted',
    published = 'published'
}

export type VisibilityProps = Partial<
    Pick<DocumentWithPublicity, 'publishedAt' | 'unpublishedAt' | 'finishedAt' | 'finished'>
>

export enum VisibilityChangeAction {
    PUBLISH, // Unlisted || Private => Published
    UNPUBLISH, // Published => Unlisted || Private
    CHANGE, // Unlisted || Private => Unlisted || Private
    NONE // No change
}
